export default function blobToFileList(blob: Blob, fileType: string): FileList {
  const file = new File([blob], `file${Date.now()}.${fileType}`);
  const dataTransfer = new DataTransfer();
  dataTransfer.items.add(file);
  return dataTransfer.files;
}
